/** Home page FAQ items, shared with the FAQPage JSON-LD (src/seo/structuredData.ts). */
export const HOME_FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8", "q9"] as const;
